import React, { useEffect, useState } from 'react';
import { Empty, Modal } from 'antd';
import styles from "./PrivacyPolicy.module.css";
import { useDispatch, useSelector } from 'react-redux';
import { SubmitButton, TextComponent } from "../../components";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Editor } from "primereact/editor";
import { showAlert } from "../../Store/Actions/GeneralActions";
import { RiEditFill } from "react-icons/ri";
import { PagesMiddleware } from '../../Store/Middlewares/PagesMiddleware';


const PrivacyPolicy = () => {


  const [createTerms, setCreateTerms] = useState('');
  const [createTermsModal, setCreateTermsModal] = useState(false);
  const [editTermsModal, setEditTermsModal] = useState(false);
  const dispatch = useDispatch();
  const [editTerms, setEditTerms] = useState('');

  const [data, setData] = useState(null)

  useEffect(() => {
    getData()
  }, []);

  const getData = () => {
    dispatch(PagesMiddleware.getPage({key: 'privacy'}))
      .then((res) => {
        setData(res)
      })
      .catch((err) => { console.log("error", err) });
  }

  const onCreatePage = () => {
    if (!createTerms) {
      dispatch(showAlert({ type: "warning", message: `Terms & Conditions can't be empty!` }));
    } else {
      dispatch(PagesMiddleware.createPage({ description: createTerms, key: 'privacy' }))
        .then((res) => {
          setCreateTermsModal(false);
          setData(res);
        })
        .catch((err) => { console.log("error", err) });
    }
  }

  const onEditPage = () => {
    if (!editTerms || editTerms == "<h2><br></h2>") {
      dispatch(showAlert({ type: "warning", message: `Terms & Conditions can't be empty!` }));
    } else {
      dispatch(PagesMiddleware.updatePage({ description: editTerms, id: data?._id, key: 'privacy' }))
        .then((res) => { 
          setData(res);
          setEditTermsModal(false);
         })
        .catch((err) => { console.log("error", err) });
    }
  }


  return (
    <div>
     
        <div className={styles.mainCon}>
        <div className={styles.flexxDiv} >

          <TextComponent text={"Privacy Policy"} className={styles.heading}/>
        

          {!data ? (
            <div>
              <SubmitButton
                className={styles.createBtn}
                title={"Create Privacy Policy"}
                onClick={()=>setCreateTermsModal(true)}
                primary
              />
            </div>
          ) : 
          <div className={styles.editDltBtnDiv}>
            <SubmitButton
                className={styles.editDltBtn}
                title={"Edit"}
                onClick={()=>{setEditTerms(data?.description); setEditTermsModal(true)}}
                rightIcon={<RiEditFill size={15} style={{marginLeft: "5px"}}/>}
              />
            </div>

          }

          </div>

          <span dangerouslySetInnerHTML={{ __html: data?.description }} style={{lineHeight: 2}} />
          {!data && <Empty />}
        </div>
      

      <Modal
        footer={false}
        closeIcon={<AiOutlineCloseCircle color="black" size={20} />}
        open={createTermsModal}
        onCancel={()=>{
            setCreateTerms('');
            setCreateTermsModal(false)
        }}
      >
        <div className={styles.modal}>
            <TextComponent text={"Create Privacy Policy"} className={styles.modalheading}/>
          <div className="card">
            <Editor
              value={createTerms}
              onTextChange={(e) => setCreateTerms(e.htmlValue)}
              style={{ height: "320px" }}
            />
          </div>
          <SubmitButton
            title={"Create"}
            btnClass={styles.modalBtn}
            primary
            onClick={onCreatePage}
          />
        </div>
      </Modal>

      <Modal
        footer={false}
        closeIcon={<AiOutlineCloseCircle color="black" size={20} />}
        open={editTermsModal}
        onCancel={()=>{
            // setEditTerms('');
            setEditTermsModal(false)
        }}
      >
        <div className={styles.modal}>
            <TextComponent text={"Edit Privacy Policy"} className={styles.modalheading}/>
          <div className="card">
            <Editor
              value={editTerms}
              onTextChange={(e) => setEditTerms(e.htmlValue)}
              style={{ height: "320px" }}
            
            />
          </div>
          <SubmitButton
            title={"Save"}
            primary
            btnClass={styles.modalBtn}
            onClick={onEditPage}
          />
        </div>
      </Modal>
    </div>
  );
};

export default PrivacyPolicy;
